'use client'

import { ThemeProvider, createTheme } from '@mui/material'
import { ReactNode } from 'react'

interface Props {
  children: ReactNode
}

const theme = createTheme({
  typography: {
    fontFamily: 'Noto Sans JP, sans-serif',
  },
  components: {
    MuiButton: {
      defaultProps: {
        variant: 'contained',
      },
      styleOverrides: {
        root: {
          borderRadius: '999px',
          padding: '12px 16px',
          boxShadow: 'none',
        },
      },
    },
  },
})

export const Providers = ({ children }: Props) => {
  return (
    <>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </>
  )
}
